export default class Team {
	constructor(team) {
		this.teamId = team.teamId ?? "";
		this.name = team.name ?? "";
		this.isArchived = team.isArchived ?? false;
		this.teamTagIds = team.teamTagIds ?? [];
	}
}
